export default "__VITE_ASSET__DCvU_Mi4__"